import React, { Component } from 'react'
import Swal from 'sweetalert2'
import Constant from '../../Constant?.js'
import axios from 'axios'
import Moment from 'react-moment'
import moment from 'moment'
import { getCountryTimeZone, getCurrency } from '../../Constant.js'
import { Modal } from 'react-responsive-modal'
import RefundModel from '../Booking/Refund.js'
import CheckPermission from '../../common/Permissions/CheckPermission.js'
import { Link } from 'react-router-dom'
import ComplaintModel from '../Booking/Complaint.js'
import ComplaintActionModel from '../Booking/ComplaintAction.js'
import Button from '../../common/CustomComponents/Button.js'
import { base64ToImageDownload, base64ToPdfDownload } from '../../common/Utils.js'
import { WaveLoading } from 'react-loadingg'

class StoreBookingDetails extends Component {
  state = {
    bookingDetails: {},
    currency: 'KD',
    orderAmount: '0.000',
    orderStatus: 'PENDING',
    refundModel: false,
    refunded_amount: 0,
    complaintModel: false,
    complaintActionModel: false,
    showCateringItems: false,
    addOn_id: null,
    isLoading: false,
    selectedComplaintId: '',
  }

  style = {
    tableData: {
      padding: 5,
      paddingLeft: 10,
      border: '1px solid #fff',
      background: '#eee',
    },
    tableDataPaid: {
      background: '#eee',
    },
    cateringCell: {
      paddingLeft: 10,
      paddingTop: 8,
      paddingBottom: 5,
      background: '#999',
    },
  }

  componentDidMount() {
    this.loadOrderDetails()
  }

  loadOrderDetails = async () => {
    await axios
      .get(Constant?.getAPI() + '/store/store-orders/' + this.props?.match?.params?.id, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res?.data?.success) {
          let response = res?.data?.data
          this.setState({
            bookingDetails: response,
            currency: getCurrency(response?.country),
          })

          if (
            response?.store_orders &&
            response?.store_orders.length > 0 &&
            response?.store_orders[0]?.order_items &&
            response?.store_orders[0]?.order_items.length > 0
          ) {
            let orderAmount = 0

            response?.store_orders[0]?.order_items.forEach((element) => {
              orderAmount = orderAmount + element.net_amount
            })

            this.setState({
              orderAmount,
            })
          }

          if (
            response.order_statuses &&
            response.order_statuses.length &&
            response.order_statuses[response.order_statuses.length - 1]?.status?.name_en
          ) {
            this.setState({
              orderStatus: response.order_statuses[response.order_statuses.length - 1]?.status?.name_en,
            })
          }

          let refudedAmount = response?.account_refund

          if (response?.user?.wallet?.length > 0) {
            refudedAmount += response.user?.wallet?.reduce((acc, ele) => {
              return acc + ele.amount
            }, 0)
          }
          this.setState({
            refunded_amount: refudedAmount,
          })
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant?.getAuthLogout()
        } else {
          Swal?.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  onPrint = () => {
    var that = this
    window.onbeforeprint = function () {
      document.getElementById('admin_menu').classList.remove('pcoded-navbar')
      document.getElementById('admin_content').classList.remove('pcoded-content')
      document.getElementById('store-order-header').style.display = 'none'
      document.getElementById('store-order-logo').style.display = 'block'

      document.getElementById('store-order-header').style.position = 'absolute'
      document.getElementById('store-order-header').style.top = '0'
      document.getElementById('store-order-header').style.left = '0'

      document.getElementsByTagName('nav')[0].style.display = 'none'
      document.getElementById('storeOrderDetailHistory').style.display = 'none'
      document.title = `invoice - #${that.state.bookingDetails.order_number}`
    }
    window.onafterprint = function () {
      document.getElementById('admin_menu').classList.add('pcoded-navbar')
      document.getElementById('admin_content').classList.add('pcoded-content')
      document.getElementById('store-order-header').style.display = 'block'
      document.getElementById('store-order-logo').style.display = 'none'

      document.getElementById('store-order-header').style.position = 'unset'
      document.getElementById('store-order-header').style.top = 'unset'
      document.getElementById('store-order-header').style.left = 'unset'

      document.getElementsByTagName('nav')[0].style.display = 'block'
      document.getElementById('storeOrderDetailHistory').style.display = 'flex'
      document.title = 'Waves'
    }
    window.print()
  }

  cancelBooking = async () => {
    Swal.fire({
      title: 'Are you sure to Cancel Booking?',
      showDenyButton: true,
      showCancelButton: true,
      confirmButtonText: `Yes`,
      denyButtonText: `No`,
    }).then(async (result) => {
      if (result.isConfirmed) {
        await axios
          .post(
            Constant.getAPI() + '/store/update-order-status',
            {
              comment: localStorage.getItem('loged_In_role') == 'store' ? 'Cancel by Store Admin' : 'Cancel by Admin',
              bookingId: this.state?.bookingDetails?.id,
              statusId: 7,
            },
            {
              headers: {
                Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
                country_short_name: `${localStorage.getItem('countryShortName')}`,
              },
            }
          )
          .then(() => {
            Swal.fire('Cancelled !', 'Booking Cancelled', 'success')
            this.loadOrderDetails()
          })
          .catch((err) => {
            if (err?.response?.status === 401) {
              Constant.getAuthLogout()
            } else {
              Swal.fire({
                title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
                icon: 'error',
                text: '',
                type: 'error',
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Ok',
              })
            }
          })
      } else if (result.isDenied) {
        Swal.fire('Changes are not saved', '', 'info')
      }
    })
  }

  processRefund = async (state) => {
    if (!state?.refund_type) {
      Swal.fire('Refund Type Required!', '', 'error')
      return
    }
    this.setState({
      refundModel: false,
    })
    const data = {
      booking_id: this.state.bookingDetails.id,
      refund_type: state?.refund_type,
      refund_amount: state?.refund_amount,
      comment_en: `Amount of ${state?.refund_amount} refunded to ${state?.refund_type} - ${state?.comment_en}`,
      comment_ar: `كمية ${state?.refund_amount} ردها إلى ${state?.refund_type} - ${state?.comment_ar}`,
    }
    await axios
      .post(Constant.getAPI() + '/store/order-refund', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Refund Processed', 'success')
          this.loadOrderDetails()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  postComplaint = async (state) => {
    if (!state?.title) {
      Swal.fire('Title is Required!', '', 'error')
      return
    }
    if (!state?.description) {
      Swal.fire('Description is Required!', '', 'error')
      return
    }

    this.setState({
      complaintModel: false,
      isLoading: true,
    })

    const data = {
      booking_id: this.state.bookingDetails.id,
      title: state?.title,
      description: state?.description,
      type: 'S',
    }

    await axios
      .post(Constant.getAPI() + '/admin/post-complaint', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Complaint raised successfully', 'success')
          this.loadOrderDetails()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  syncPayment = async (paymentId) => {
    if (!paymentId) {
      Swal.fire({
        title: 'Payment ID is required',
        icon: 'error',
        type: 'error',
      })
      return
    }

    Swal.fire({
      title: 'Syncing Payment...',
      text: 'Please wait while we sync the payment status',
      allowOutsideClick: false,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    await axios
      .get(Constant.getAPI() + `/admin/sync-order-payment/${paymentId}`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then(() => {
        this.loadOrderDetails()
        Swal.fire('Success', 'Payment synced successfully', 'success')
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            type: 'error',
          })
        }
      })
  }

  handleComplaintAction = (complaintId) => {
    this.setState({ complaintActionModel: true, selectedComplaintId: complaintId })
  }

  postAction = async (state) => {
    if (!state?.action) {
      Swal.fire('Action is Required!', '', 'error')
      return
    }
    if (!state?.note) {
      Swal.fire('Note is Required!', '', 'error')
      return
    }

    this.setState({
      complaintActionModel: false,
      isLoading: true,
    })

    const data = {
      complaint_id: this.state.selectedComplaintId,
      action: state?.action,
      note: state?.note,
      type: 'S',
    }

    await axios
      .post(Constant.getAPI() + '/admin/post-complaint-action', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Complaint updated successfully', 'success')
          this.loadOrderDetails()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  handleStatusChange = async (id, status) => {
    const data = {
      complaint_id: id,
      status: status,
      type: 'S',
    }

    await axios
      .post(Constant.getAPI() + '/admin/update-complaint', data, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
      })
      .then((res) => {
        if (res.status === 200) {
          Swal.fire('Success !', 'Status updated successfully', 'success')
          this.loadOrderDetails()
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
  }

  downloadTicket = async (type, order_number, ticket_for = 'user') => {
    this.setState({
      isLoading: true,
    })

    await axios
      .get(Constant?.getAPI() + `/auth/booking-tickets-v2`, {
        headers: {
          Authorization: `Bearer ${localStorage?.getItem('loged_In_auth')}`,
          country_short_name: `${localStorage.getItem('countryShortName')}`,
        },
        params: {
          type: 'O',
          order_number,
          ticket_for,
          lang: 'en',
          content_type: 'base64',
        },
      })
      .then(async (res) => {
        if (type == 'pdf') {
          base64ToPdfDownload(res.data, `store-order-${order_number}`)
        } else {
          base64ToImageDownload(res.data, `store-order-${order_number}`)
        }
      })
      .catch((err) => {
        if (err?.response?.status === 401) {
          Constant.getAuthLogout()
        } else {
          Swal.fire({
            title: err?.response?.data?.data?.details?.[0]?.message || err?.response?.data?.message,
            icon: 'error',
            text: '',
            type: 'error',
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ok',
          })
        }
      })
      .finally(() => {
        this.setState({
          isLoading: false,
        })
      })
  }

  showDetails = (type) => {
    switch (type) {
      case 'payment':
        var content
        if (this.state?.bookingDetails?.payment_details?.length > 0) {
          content = `<div><table style="width:100%">
              <tbody>
                <tr>
                <th></th>
                ${this.state?.bookingDetails?.payment_details.map((item, index) => `<th style="text-align: left">Payment ${index + 1}</th>`)}
                </tr>
                <tr>
                <th>Payment ID</th>
                ${this.state?.bookingDetails?.payment_details.map((item) => `<td style="text-align: left">${item.payment_id || '--'}</td>`)}
                </tr>
                <tr>
                <th>Payment Status</th>
                ${this.state?.bookingDetails?.payment_details
                  .map(
                    (item) =>
                      `<td style="text-align: left">
                      ${item.payment_status || '--'}
                      ${
                        (item.payment_status === 'INITIATED' ||
                          item.payment_status === 'FAILED' ||
                          item.payment_status === 'PENDING') &&
                        item.payment_method_Id === 1
                          ? `<i 
                            class="icofont icofont-refresh" 
                            onclick="window.syncOrderPaymentHandler('${item.id}')" 
                            style="margin-left: 10px; cursor: pointer; color: #007bff; font-size: 18px;" 
                            title="Sync Payment">
                          </i>`
                          : ''
                      }
                    </td>`
                  )
                  .join('')}
                </tr>
                <tr>
                <th>Payment Method</th>
                ${this.state?.bookingDetails?.payment_details.map((item) => '<td style="text-align: left">' + (item?.payment_method?.PaymentMethod_en || '--') + '</td>')}
                </tr>
                <tr>
                  <th>Payment Amount</th>
                  ${this.state?.bookingDetails?.payment_details
                    .map(
                      (item) => `
                    <td style="text-align: left; ${item.payment_amount < 0 ? 'background-color: red; color: white;' : ''}">
                      ${item.payment_currency || this.state.currency} ${item.payment_amount}
                    </td>
                  `
                    )
                    .join('')}
                </tr>
                <tr>
                <th>Transaction ID</th>
                ${this.state?.bookingDetails?.payment_details.map((item) => '<td style="text-align: left">' + (item.txn_id || '--') + '</td>')}
                </tr>
                <tr>
                <th>Invoice Reference ID</th>
                ${this.state?.bookingDetails?.payment_details.map((item) => '<td style="text-align: left">' + (item.payment_info.InvoiceReference || '--') + '</td>')}
                </tr>
                <tr>
                <th>Payment Created at</th>
                ${this.state?.bookingDetails?.payment_details.map((item) => '<td style="text-align: left">' + (item.createdAt ? moment(item.createdAt).format('YYYY-MM-DD HH:mm') : '--') + '</td>')}
                </tr>
              </tbody>
              </table>
              </div>
            `

          // Attach sync payment handler to window for button onclick
          window.syncOrderPaymentHandler = (paymentId) => {
            this.syncPayment(paymentId)
          }

          Swal.fire({
            width: '1000px',
            title: '<strong>Payment Details</strong>',
            html: content,
          })
        } else {
          Swal.fire({
            title: '<strong>Payment Details Not Found</strong>',
            icon: 'error',
            type: 'error',
          })
        }
        break
      default:
        break
    }
  }

  render() {
    return (
      <div className="pcoded-inner-content">
        {this.state.isLoading == true && (
          <div
            style={{
              position: 'fixed',
              top: 0,
              right: 0,
              width: '100%',
              height: '100%',
              background: 'rgba(0,0,0,0.5)',
              zIndex: 10000,
            }}
            onClick={(e) => {
              e.preventDefault()
            }}
          >
            <WaveLoading />
          </div>
        )}
        <Modal
          open={this.state.refundModel}
          onClose={() => {
            this.setState({ refundModel: false })
          }}
          center
        >
          <RefundModel
            refundAmount={
              this.state?.bookingDetails?.bookingDetails?.payment_amount +
                this.state?.bookingDetails?.wallet_amount_applied -
                this.state?.refunded_amount || '0'
            }
            processRefund={this.processRefund}
          ></RefundModel>
        </Modal>
        <Modal
          open={this.state.complaintModel}
          onClose={() => {
            this.setState({ complaintModel: false })
          }}
          center
        >
          <ComplaintModel
            postComplaint={this.postComplaint}
            type={'S'}
          ></ComplaintModel>
        </Modal>
        <Modal
          open={this.state.complaintActionModel}
          onClose={() => {
            this.setState({ complaintActionModel: false })
          }}
          center
        >
          <ComplaintActionModel
            postAction={this.postAction}
            type={'S'}
          ></ComplaintActionModel>
        </Modal>
        <div className="main-body">
          <div className="page-wrapper">
            <div
              id="store-order-logo"
              style={{ display: 'none' }}
            >
              <img
                className="img-fluid img-100"
                src="./assets/images/icon.png"
                alt="Theme-Logo"
              />
            </div>
            <div
              className="page-header"
              id="store-order-header"
            >
              <div className="row align-items-end">
                <div className="col-lg-3">
                  <div className="page-header-title">
                    <div className="d-inline">
                      <h4>Order History</h4>
                    </div>
                  </div>
                </div>
                <div className="text-right col-lg-9">
                  {this.state.orderStatus != 'CANCELLED' && (
                    <Button
                      onClick={() => this.cancelBooking()}
                      className="btn hor-grd btn-grd-disabled mr-2"
                      style={{ width: 130, background: '#d00' }}
                    >
                      Cancel
                    </Button>
                  )}
                  <Button
                    className="btn btn-grd-disabled mr-2"
                    onClick={() => this.onPrint()}
                    style={{ width: 130, background: '#00d' }}
                  >
                    Print
                  </Button>
                  <CheckPermission permission={'refund-booking'}>
                    <Button
                      className="btn btn-inverse mr-2"
                      onClick={() => {
                        this.setState({ refundModel: true })
                      }}
                      disabled={
                        this.state?.refunded_amount >=
                        this.state?.bookingDetails?.bookingDetails?.payment_amount +
                          this.state?.bookingDetails?.wallet_amount_applied
                      }
                    >
                      <i className="icofont icofont-ui-rotation m-r-5"></i> Refund
                    </Button>
                  </CheckPermission>
                  <Button
                    className="btn btn-inverse"
                    style={{ backgroundColor: '#ee3a28' }}
                    onClick={() => {
                      if (localStorage.getItem('countryShortName') != this.state.bookingDetails.country) {
                        Swal.fire(
                          '',
                          `Please change country to ${this.state.bookingDetails.country} for edit this booking details`,
                          'error'
                        )
                        return
                      }
                      this.setState({ complaintModel: true })
                    }}
                  >
                    <i className="icofont icofont-contacts m-r-5"></i> Raise Complaint
                  </Button>
                  <Button
                    startIcon={<i className="icofont icofont-download m-r-5"></i>}
                    onClick={() => {
                      this.downloadTicket('image', this.state.bookingDetails.order_number)
                    }}
                  >
                    User Ticket Image
                  </Button>
                  <Button
                    startIcon={<i className="icofont icofont-download m-r-5"></i>}
                    onClick={() => {
                      this.downloadTicket('pdf', this.state.bookingDetails.order_number)
                    }}
                  >
                    User Ticket PDF
                  </Button>
                </div>
              </div>
            </div>
            <div
              className="page-body"
              id="store-order-details"
            >
              <div className="row">
                <div className="col-sm-12">
                  <div className="card">
                    <div className="card-block">
                      <div
                        className="row"
                        style={{ padding: 10, borderBottom: '1px solid #ddd' }}
                      >
                        <div
                          className="col-md-6 col-sm-12"
                          style={{ borderRight: '1px solid #ddd' }}
                        >
                          <div
                            className="row"
                            style={{ marginBottom: 10 }}
                          >
                            <div
                              className="col-4"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Order Details</div>
                            </div>
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Order ID</div>
                              <div>Order Status</div>
                              <div>Order Placed Time</div>
                              <div>Order Duration</div>
                              <div>Order Delivery Time</div>
                            </div>
                            <div className="col-5">
                              <div style={{ fontWeight: 'bolder' }}>
                                {this.state?.bookingDetails?.order_number || '--'}
                              </div>
                              <div style={{ fontWeight: 'bolder', color: 'green' }}>
                                {this.state.orderStatus == 'CANCELLED' || this.state.orderStatus == 'PENDING' ? (
                                  <span className="badge badge-pill badge-warning">{this.state.orderStatus}</span>
                                ) : (
                                  <span className="badge badge-pill badge-success">{this.state.orderStatus}</span>
                                )}
                              </div>
                              <div>
                                {this.state?.bookingDetails?.bookingDetails?.createdAt ? (
                                  <Moment format="DD/MM/YYYY hh:mm A">
                                    {this.state?.bookingDetails?.bookingDetails?.createdAt}
                                  </Moment>
                                ) : (
                                  '--'
                                )}
                              </div>
                              <div>{this.state?.bookingDetails?.expected_delivery_datetime ? 'Scheduled' : '--'}</div>
                              <div>
                                {this.state?.bookingDetails?.expected_delivery_datetime
                                  ? moment
                                      .utc(this.state?.bookingDetails?.expected_delivery_datetime)
                                      .format('DD/MM/YYYY hh:mm A')
                                  : '--'}
                              </div>
                            </div>
                          </div>
                          <div
                            className="row"
                            style={{ marginBottom: 10 }}
                          >
                            <div
                              className="col-4"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Store Details</div>
                            </div>
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Store Name</div>
                              <div>Store Phone</div>
                            </div>
                            <div className="col-5">
                              <div>
                                {this.state?.bookingDetails?.store_orders?.length > 0 &&
                                  (this.state?.bookingDetails?.store_orders[0]?.shop_name || '--')}
                              </div>
                              <div>
                                {this.state?.bookingDetails?.store_orders?.length > 0 &&
                                this.state?.bookingDetails?.store_orders[0]?.store?.store_supplier?.country_code &&
                                this.state?.bookingDetails?.store_orders[0]?.store?.store_supplier?.phone
                                  ? this.state?.bookingDetails?.store_orders[0]?.store?.store_supplier?.country_code.replace(
                                      '+',
                                      ''
                                    ) +
                                    ' ' +
                                    this.state?.bookingDetails?.store_orders[0]?.store?.store_supplier?.phone
                                  : '--'}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-md-6 col-sm-12">
                          <div
                            className="row"
                            style={{ marginBottom: 10 }}
                          >
                            <div
                              className="col-4"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>User Details</div>
                            </div>
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Customer Name</div>
                              <div>Phone</div>
                              {localStorage.getItem('loged_In_role') != 'store' && (
                                <>
                                  <div>Email</div>
                                  <div>Device Type</div>
                                  <div>Device Name</div>
                                  <div>Profile</div>
                                </>
                              )}
                            </div>
                            <div className="col-5">
                              <div>
                                {this.state?.bookingDetails?.user?.first_name &&
                                this.state?.bookingDetails?.user?.last_name
                                  ? this.state?.bookingDetails?.user?.first_name +
                                    ' ' +
                                    this.state?.bookingDetails?.user?.last_name
                                  : '--'}
                              </div>
                              <div>
                                {this.state?.bookingDetails?.user?.country_code &&
                                this.state?.bookingDetails?.user?.phone
                                  ? this.state?.bookingDetails?.user?.country_code.replace('+', '') +
                                    ' ' +
                                    this.state?.bookingDetails?.user?.phone
                                  : '--'}
                              </div>
                              {localStorage.getItem('loged_In_role') != 'store' && (
                                <>
                                  <div>{this.state?.bookingDetails?.user?.email || '--'}</div>
                                  <div>
                                    {this.state?.bookingDetails?.device_type == 'W'
                                      ? 'Website'
                                      : this.state?.bookingDetails?.device_type || '--'}
                                  </div>
                                  <div>{this.state?.bookingDetails?.device_model || '--'}</div>
                                  <div>
                                    <img
                                      src={
                                        this.state?.bookingDetails?.user?.user_profile &&
                                        typeof this.state?.bookingDetails?.user?.user_profile == 'string'
                                          ? Constant.getImage() + this.state?.bookingDetails?.user?.user_profile
                                          : './assets/images/icon.png'
                                      }
                                      className="img-fluid img-40"
                                      alt="img"
                                    />
                                  </div>
                                </>
                              )}
                            </div>
                          </div>
                          <div
                            className="row"
                            style={{ marginBottom: 10 }}
                          >
                            <div
                              className="col-4"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Payment Details</div>
                            </div>
                            <div
                              className="col-3"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>
                                Payment Status
                                <img
                                  className="img-fluid m-l-5"
                                  src="./assets/images/info.png"
                                  alt="ico"
                                  style={{ width: 13 }}
                                  onClick={() => this.showDetails('payment')}
                                />
                              </div>
                              {/* <div>Payment Method</div> */}
                              <div>Discount Coupon</div>
                              <div>Payment Amount</div>
                            </div>
                            <div className="col-5">
                              <div>{this.state?.bookingDetails?.is_paid === 1 ? 'True' : 'False'}</div>
                              <div>
                                {this.state?.bookingDetails?.bulk_coupon?.coupon_code
                                  ? 'BC - ' + this.state?.bookingDetails?.bulk_coupon?.coupon_code
                                  : this.state?.bookingDetails?.coupon?.coupon_code
                                    ? 'C - ' + this.state?.bookingDetails?.coupon?.coupon_code
                                    : '--'}
                              </div>
                              <div>
                                {this.state?.bookingDetails?.bookingDetails?.payment_amount +
                                  this.state?.bookingDetails?.bookingDetails?.payment_currency || '--'}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="row"
                        style={{ padding: 10 }}
                      >
                        <div className="col-12">
                          <div className="row">
                            <div
                              className="col-2"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Delivery Address</div>
                            </div>
                            <div
                              className="col-2"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Address Type</div>
                              <div>Name</div>
                              <div>Phone</div>
                              <div>Governorate</div>
                              <div>Block</div>
                              <div>Apartment</div>
                              <div>Street</div>
                            </div>
                            <div className="col-2">
                              <div style={{ textTransform: 'capitalize' }}>
                                {this.state?.bookingDetails?.shipping_address?.address_type || '--'}
                              </div>
                              <div>
                                {this.state?.bookingDetails?.shipping_address?.first_name &&
                                this.state?.bookingDetails?.shipping_address?.last_name
                                  ? this.state?.bookingDetails?.shipping_address?.first_name +
                                    ' ' +
                                    this.state?.bookingDetails?.shipping_address?.last_name
                                  : '--'}
                              </div>
                              <div>
                                {this.state?.bookingDetails?.shipping_address?.phone_code &&
                                this.state?.bookingDetails?.shipping_address?.phone_number
                                  ? this.state?.bookingDetails?.shipping_address?.phone_code.replace('+', '') +
                                    ' ' +
                                    this.state?.bookingDetails?.shipping_address?.phone_number
                                  : '--'}
                              </div>
                              <div>{this.state?.bookingDetails?.shipping_address?.area || '--'}</div>
                              <div>{this.state?.bookingDetails?.shipping_address?.block || '--'}</div>
                              <div>{this.state?.bookingDetails?.shipping_address?.apartment || '--'}</div>
                              <div>{this.state?.bookingDetails?.shipping_address?.street || '--'}</div>
                            </div>
                            <div
                              className="col-2"
                              style={{ fontWeight: 'bold' }}
                            >
                              <div>Building</div>
                              <div>Floor</div>
                              <div>City</div>
                              <div>State</div>
                              <div>Country</div>
                              <div>Extra Directions</div>
                            </div>
                            <div className="col-2">
                              <div>{this.state?.bookingDetails?.shipping_address?.building || '--'}</div>
                              <div>{this.state?.bookingDetails?.shipping_address?.floor || '--'}</div>
                              <div>{this.state?.bookingDetails?.shipping_address?.city?.name_en || '--'}</div>
                              <div>{this.state?.bookingDetails?.shipping_address?.state?.name_en || '--'}</div>
                              <div>
                                {this.state?.bookingDetails?.shipping_address?.country?.country_name_en || '--'}
                              </div>
                              <div>{this.state?.bookingDetails?.shipping_address?.notes || '--'}</div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div
                        className="row"
                        style={{ padding: 10 }}
                      >
                        <div className="col-12">
                          <div
                            className="row"
                            style={{ borderBottom: '1px solid #ddd' }}
                          >
                            <div
                              className="col-2"
                              style={{ fontWeight: 'bold' }}
                            >
                              Delivery Items
                            </div>
                            <div className="col-10">
                              <div className="row">
                                <div className="col-sm-12">
                                  <div className="table-responsive">
                                    <table className="table">
                                      <tbody>
                                        <tr
                                          className="thead-inverse"
                                          style={{ height: 40 }}
                                        >
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>#</th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>Quantity</th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>SKU</th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>Item</th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                            Special Request
                                          </th>
                                          {/* <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>Additional Persons</th> */}
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                            Unit Price
                                          </th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                            Add Ons Price
                                          </th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>Total</th>
                                        </tr>
                                        {this.state?.bookingDetails?.store_orders?.length > 0 &&
                                          this.state?.bookingDetails?.store_orders[0]?.order_items.length > 0 &&
                                          this.state?.bookingDetails?.store_orders[0]?.order_items.map(
                                            (item, index) => (
                                              <React.Fragment key={item.id}>
                                                <tr>
                                                  <td style={{ ...this.style.tableData, fontWeight: 'bold' }}>
                                                    Item {index + 1}
                                                  </td>
                                                  <td style={this.style.tableData}>{item.quantity}</td>
                                                  <td style={this.style.tableData}>{item?.store_item?.sku || '--'}</td>
                                                  <td style={this.style.tableData}>
                                                    {item?.store_item?.item_name_en || '--'}
                                                    {item?.store_item_option?.name_en && (
                                                      <span className="text-danger">{`(${item.store_item_option.name_en})`}</span>
                                                    )}
                                                  </td>
                                                  <td style={this.style.tableData}>{item.notes || '--'}</td>
                                                  {/* <td style={this.style.tableData}>
                                                {item.additional_persons > 0 ? (
                                                  <>
                                                    <div>{item.additional_persons}</div>
                                                    {item?.store_item?.person_price && (
                                                      <div className="text-muted" style={{ fontSize: '0.8em', whiteSpace: 'nowrap' }}>
                                                        {`${this.state?.currency} ${item.store_item.person_price} x ${item.additional_persons} = ${this.state?.currency} ${item.store_item.person_price * item.additional_persons}`}
                                                      </div>
                                                    )}
                                                  </>
                                                ) : (
                                                  '0'
                                                )}
                                              </td> */}
                                                  <td style={this.style.tableData}>
                                                    {this.state?.currency + ' ' + item.price}
                                                  </td>
                                                  <td style={this.style.tableData}>
                                                    {this.state?.currency + ' ' + (item.addons_amount || 0)}
                                                  </td>
                                                  <td style={this.style.tableData}>
                                                    {this.state?.currency + ' ' + item.net_amount}
                                                  </td>
                                                </tr>
                                                {item?.catering_items?.length > 0 && (
                                                  <tr style={{ background: '#eee', border: '1px solid #ddd' }}>
                                                    <td
                                                      colSpan={8}
                                                      className=""
                                                    >
                                                      <table
                                                        key={`catering-${item.id}`}
                                                        className="table"
                                                      >
                                                        <tbody>
                                                          <tr
                                                            className="thead-inverse"
                                                            style={{ height: 20, background: '#555' }}
                                                          >
                                                            {/* <th style={this.style.cateringCell}>Category</th> */}
                                                            <th style={this.style.cateringCell}>Item Name</th>
                                                            <th style={this.style.cateringCell}>Quantity</th>
                                                            <th style={this.style.cateringCell}>Is Add-on</th>
                                                            <th style={this.style.cateringCell}>Unit Price</th>
                                                            <th style={this.style.cateringCell}>Total Price</th>
                                                          </tr>
                                                          {item?.catering_items.map((ele) => (
                                                            <tr key={ele.id}>
                                                              {/* <td
                                                            style={{
                                                              ...this.style.tableData,
                                                              background: '#eec',
                                                            }}
                                                          >
                                                            {ele?.category?.name_en || '--'}
                                                          </td> */}
                                                              <td
                                                                style={{
                                                                  ...this.style.tableData,
                                                                  background: '#eec',
                                                                }}
                                                              >
                                                                {ele?.item?.name_en || '--'}
                                                              </td>
                                                              <td
                                                                style={{
                                                                  ...this.style.tableData,
                                                                  background: '#eec',
                                                                }}
                                                              >
                                                                {ele.item_qty || '--'}
                                                              </td>
                                                              <td
                                                                style={{
                                                                  ...this.style.tableData,
                                                                  background: '#eec',
                                                                }}
                                                              >
                                                                {ele.is_addon ? (
                                                                  <span className="badge badge-success">Yes</span>
                                                                ) : (
                                                                  <span className="badge badge-secondary">No</span>
                                                                )}
                                                              </td>
                                                              <td
                                                                style={{
                                                                  ...this.style.tableData,
                                                                  background: '#eec',
                                                                }}
                                                              >
                                                                {this.state?.currency +
                                                                  ' ' +
                                                                  (ele.is_addon ? ele?.amount : 0)}
                                                              </td>
                                                              <td
                                                                style={{
                                                                  ...this.style.tableData,
                                                                  background: '#eec',
                                                                }}
                                                              >
                                                                {this.state?.currency +
                                                                  ' ' +
                                                                  (ele.is_addon ? ele?.amount * ele.item_qty : 0)}
                                                              </td>
                                                            </tr>
                                                          ))}
                                                        </tbody>
                                                      </table>
                                                    </td>
                                                  </tr>
                                                )}
                                              </React.Fragment>
                                            )
                                          )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="row"
                            style={{ borderBottom: '1px solid #ddd' }}
                          >
                            <div
                              className="col-6"
                              style={{ fontWeight: 'bold' }}
                            ></div>
                            <div className="col-6">
                              <div className="row">
                                <div className="col-sm-12">
                                  <div className="table-responsive">
                                    <table className="table">
                                      <tbody>
                                        <tr
                                          className="thead-inverse"
                                          style={{ height: 40 }}
                                        >
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                            Description
                                          </th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>Price</th>
                                        </tr>
                                        <tr style={this.style.tableDataPaid}>
                                          <td style={this.style.tableData}>Order Amount</td>
                                          <td style={this.style.tableData}>
                                            {this.state?.currency} {this.state?.orderAmount}
                                          </td>
                                        </tr>
                                        <tr style={this.style.tableDataPaid}>
                                          <td style={this.style.tableData}>Delivery Charges</td>
                                          <td style={this.style.tableData}>
                                            {this.state?.currency} {this.state?.bookingDetails?.delivery_charge}
                                          </td>
                                        </tr>
                                        <tr style={this.style.tableDataPaid}>
                                          <td style={this.style.tableData}>Vat</td>
                                          <td style={this.style.tableData}>
                                            {this.state?.currency} {this.state?.bookingDetails?.vat_charge}
                                          </td>
                                        </tr>
                                        <tr style={this.style.tableDataPaid}>
                                          <td style={this.style.tableData}>Discount Coupon</td>
                                          <td style={{ ...this.style.tableData, color: 'red' }}>
                                            {this.state?.currency} {this.state?.bookingDetails?.coupon_amount_applied}
                                          </td>
                                        </tr>
                                        <tr style={this.style.tableDataPaid}>
                                          <td style={this.style.tableData}>
                                            Wallet Amount Applied
                                            {this.state?.bookingDetails?.wallet_amount_applied > 0 && (
                                              <Link
                                                to={
                                                  '/all-users/edit/user-wallet/' + this.state?.bookingDetails?.user?.id
                                                }
                                                className="m-r-15 text-muted"
                                              >
                                                <img
                                                  className="img-fluid m-l-5"
                                                  src="./assets/images/info.png"
                                                  alt="ico"
                                                  style={{ width: 13 }}
                                                />
                                              </Link>
                                            )}
                                          </td>
                                          <td style={{ ...this.style.tableData, color: 'red' }}>
                                            {this.state?.currency} {this.state?.bookingDetails?.wallet_amount_applied}
                                          </td>
                                        </tr>
                                        <tr style={this.style.tableDataPaid}>
                                          <td style={{ ...this.style.tableData, fontWeight: 'bolder' }}>
                                            Total Amount
                                          </td>
                                          <td style={{ ...this.style.tableData, fontWeight: 'bolder' }}>
                                            {this.state?.bookingDetails?.bookingDetails?.payment_amount
                                              ? this.state?.currency +
                                                ' ' +
                                                this.state?.bookingDetails?.bookingDetails?.payment_amount
                                              : this.state?.currency + ' 0.000'}
                                          </td>
                                        </tr>
                                        {this.state?.refunded_amount > 0 && (
                                          <>
                                            <tr>
                                              <td></td>
                                            </tr>
                                            <tr style={this.style.tableDataPaid}>
                                              <td style={{ ...this.style.tableData, fontWeight: 'bolder' }}>
                                                Refunded Amount
                                              </td>
                                              <td style={{ ...this.style.tableData, fontWeight: 'bolder' }}>
                                                {this.state?.currency + ' ' + this.state.refunded_amount}
                                              </td>
                                            </tr>
                                          </>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="row"
                            style={{ paddingTop: 10 }}
                            id="storeOrderDetailHistory"
                          >
                            <div
                              className="col-2"
                              style={{ fontWeight: 'bold' }}
                            >
                              Order History
                            </div>
                            <div className="col-10">
                              <div className="row">
                                <div className="col-sm-12">
                                  <div className="table-responsive">
                                    <table className="table">
                                      <tbody>
                                        <tr
                                          className="thead-inverse"
                                          style={{ height: 40 }}
                                        >
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>Status</th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>Comments</th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                            Change Time
                                          </th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                            Change By
                                          </th>
                                        </tr>
                                        {this.state?.bookingDetails?.order_statuses?.length > 0 &&
                                          this.state?.bookingDetails?.order_statuses.map((item) => (
                                            <tr key={item.id}>
                                              <td style={this.style.tableData}>{item?.status?.name_en}</td>
                                              <td style={this.style.tableData}>{item?.comment}</td>
                                              <td style={this.style.tableData}>
                                                {<Moment format="DD/MM/YYYY hh:mm A">{item?.created_at}</Moment> ||
                                                  '--'}
                                              </td>
                                              <td style={this.style.tableData}>
                                                {item?.user?.first_name} {item?.user?.last_name}
                                              </td>
                                            </tr>
                                          ))}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                          <div
                            className="row"
                            style={{ marginTop: 10 }}
                          >
                            <div
                              className="col-2"
                              style={{ fontWeight: 'bold' }}
                            >
                              Complaint History
                            </div>
                            <div className="col-10">
                              <div className="row">
                                <div className="col-sm-12">
                                  <div className="table-responsive">
                                    <table className="table">
                                      <tbody>
                                        <tr
                                          className="thead-inverse"
                                          style={{ height: 40 }}
                                        >
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>Title</th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                            Description
                                          </th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>Status</th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                            Action Taken
                                          </th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                            Change Time
                                          </th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                            Created by
                                          </th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>
                                            Updated by
                                          </th>
                                          <th style={{ paddingLeft: 10, paddingTop: 8, paddingBottom: 5 }}>Action</th>
                                        </tr>
                                        {this.state?.bookingDetails?.complaints?.length > 0 ? (
                                          this.state?.bookingDetails?.complaints?.map((booking) => {
                                            return (
                                              <tr
                                                key={booking.id}
                                                style={this.style.tableDataPaid}
                                              >
                                                <td style={this.style.tableData}>{booking.title}</td>
                                                <td style={this.style.tableData}>{booking.description}</td>
                                                <td style={this.style.tableData}>
                                                  <select
                                                    style={{ minWidth: 150 }}
                                                    className={`form-control`}
                                                    value={booking.status}
                                                    onChange={(e) =>
                                                      this.handleStatusChange(booking.id, e.target.value)
                                                    }
                                                  >
                                                    <option value="Open">Open</option>
                                                    <option value="In Progress">In Progress</option>
                                                    <option value="Resolved">Resolved</option>
                                                    <option value="Closed">Closed</option>
                                                  </select>
                                                </td>
                                                <td style={this.style.tableData}>{booking.action}</td>
                                                <td style={this.style.tableData}>
                                                  {moment(booking.created_at)
                                                    .tz(getCountryTimeZone(localStorage.getItem('countryShortName')))
                                                    .format('YYYY-MM-DD HH:mm:ss')}
                                                </td>
                                                <td style={this.style.tableData}>
                                                  {booking.created_user?.first_name} {booking.created_user?.last_name}{' '}
                                                  <b>({booking.created_user?.user_type})</b>
                                                </td>
                                                <td style={this.style.tableData}>
                                                  {booking.updated_user?.first_name} {booking.updated_user?.last_name}{' '}
                                                  <b>({booking.updated_user?.user_type})</b>
                                                </td>
                                                <td style={{ ...this.style.tableData, paddingLeft: 35 }}>
                                                  <i
                                                    className="icofont icofont-edit"
                                                    style={{ cursor: 'pointer' }}
                                                    onClick={() => this.handleComplaintAction(booking.id)}
                                                  ></i>
                                                </td>
                                              </tr>
                                            )
                                          })
                                        ) : (
                                          <tr style={this.style.tableDataPaid}>
                                            <td style={this.style.tableData}>{'--'}</td>
                                            <td style={this.style.tableData}>{'--'}</td>
                                            <td style={this.style.tableData}>{'--'}</td>
                                            <td style={this.style.tableData}>{'--'}</td>
                                            <td style={this.style.tableData}>{'--'}</td>
                                            <td style={this.style.tableData}>{'--'}</td>
                                            <td style={this.style.tableData}>{'--'}</td>
                                            <td style={this.style.tableData}>{'--'}</td>
                                          </tr>
                                        )}
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

export default StoreBookingDetails
